import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Divider, Image, Paper, Stack, Text, rem } from '@mantine/core';
export const ProfileEmailSuccess: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setVerifyStatus
  } = useVerifyProfile();
  return <Stack justify="center" align="center" h="100%" p={{
    base: 24,
    sm: 10
  }}>
      <Stack align="center" w={{
      sm: 369,
      lg: 'auto'
    }}>
        <Stack hiddenFrom="sm">
          <Text fz={rem(20)} className={gunterzBold.className} ta="center">
            {i18n._('your primeorb can be minted on the eth network, allowing you to sell it on our upcoming marketplace')}
          </Text>
          <Divider size="sm" c="var(--icon-primary)" />

          <Text fz={rem(12)} tt="uppercase" c="var(--text-dark)" ta="center">
            {i18n._('(YOU’LL LOSE ALL OF IT’S BENEFITS IF SOLD, SO BETTER KEEP IT!)')}
          </Text>

          <Divider size="sm" c="var(--icon-primary)" />
        </Stack>

        <Paper px={20} py={34} bd="2px dashed var(--text-green)" bg="#1A1F26F2" pos="relative">
          <Image src="/assets/kyc/mail_box.svg" alt="mail-box" w={52} h={52} mx="auto" pos="absolute" top={-30} left={0} right={0} />
          <Text fz={rem(18)} c="var(--text-green)" className={gunterzBold.className} ta="center">
            {i18n._('EMAIL VERIFIED SUCCESSFULLY')}
          </Text>
          <Text fz={rem(12)} c="var(--text-dark)" tt="uppercase" fw={700} ta="center">
            {i18n._('THANKS, Let’s continue:')}
          </Text>
        </Paper>

        <Button w={142} h={46} mt={30} fz="xs" classNames={{
        root: btnStyle.root
      }} leftSection={<Icons className="icon-pr-line-log-in" fontSize={25} />} onClick={() => setVerifyStatus(PROFILE_STATUS.COMPLETE)}>
          {i18n._('Next step')}
        </Button>
      </Stack>
    </Stack>;
};